import React from 'react'
import { RealEstateDataPageComponentData } from 'types'

const DevCard_3v1_01 = (props: RealEstateDataPageComponentData) => {
  const Card = require(`../3`)?.default
  return <Card {...props} />
}

export default DevCard_3v1_01
